var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCursos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_3045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8554 24.3246L44.276 22.7028C46.0242 22.0614 46.0242 19.5889 44.276 18.9476L24.9731 11.8656C24.5284 11.7025 24.0402 11.7025 23.5954 11.8656L4.29256 18.9476C2.54438 19.5889 2.54438 22.0614 4.29255 22.7028L9.1209 24.4742M39.8554 24.3246L24.9731 29.7847C24.5284 29.9479 24.0402 29.9479 23.5954 29.7847L9.1209 24.4742M39.8554 24.3246L39.8554 35.9982C39.8554 36.4661 39.7027 36.926 39.4107 37.2916C38.1838 38.8281 34.9961 42.0214 23.9583 42.0214C16.8284 42.0214 10.4818 39.4763 9.2457 37.0203C9.14906 36.8283 9.1209 36.6128 9.1209 36.3978L9.1209 24.4742",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_3045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursos);
export default __webpack_public_path__ + "static/media/cursos.72c36c4bb16aadb4b9f60746ae6bc886.svg";
export { ForwardRef as ReactComponent };